// extracted by mini-css-extract-plugin
export var disabled = "_1l-a";
export var hierarchyLinkGray = "_1l-4";
export var hierarchyLinkUnderline = "_1l-3";
export var hierarchyPrimary = "_1l-0";
export var hierarchySecondary = "_1l-1";
export var hierarchyTertiary = "_1l-2";
export var pressed = "_1l-6";
export var themeAction = "_1l-5";
export var themeDestructive = "_1l-8";
export var themeNormal = "_1l-7";
export var themeSuccess = "_1l-9";